import { ButtonStatus } from '@/components/Button/Button.types';
import { ActivateSsoLoginDocument, EntraMatch } from '@/generated/graphql';
import { useMutation } from '@vue/apollo-composable';
import { Ref, ref } from 'vue';
import { invalidateUserList } from '../userListCache';

export function useActivateSsoLogin() {
    const activateSsoLoginMutation = useMutation(ActivateSsoLoginDocument, { update: invalidateUserList });
    const activationRunning = ref(false);
    const activationButtonStatus: Ref<Map<string, ButtonStatus>> = ref(new Map());

    async function activateSsoLogin(inactiveLogin: EntraMatch, userId: string) {
        if (activationRunning.value === true) return;
        activationRunning.value = true;
        activationButtonStatus.value.set(userId, 'Loading');
        const providerToActivate = inactiveLogin.provider;

        try {
            const result = await activateSsoLoginMutation.mutate({
                userId,
                oid: inactiveLogin.id,
                provider: providerToActivate,
            });
            if (result?.errors) {
                activationButtonStatus.value.set(userId, 'Error');
                activationRunning.value = false;
                throw new Error(`Could not activate Sso Login: ${result.errors}`);
            }
            if (result?.data) {
                const typename = result.data.activateSsoLogin.__typename;
                if (typename === 'SsoLoginData') {
                    activationButtonStatus.value.set(userId, 'Success');
                    activationRunning.value = false;
                    activationButtonStatus.value.set(userId, 'Default');
                } else {
                    activationButtonStatus.value.set(userId, 'Error');
                    activationRunning.value = false;
                }
            }
        } finally {
            activationRunning.value = false;
        }
    }

    return {
        activationRunning,
        activationButtonStatus,
        activateSsoLogin,
    };
}
